<template>
    <div id="GeGHS">
        <h1>GHS</h1>
    </div>
</template>